import * as React from 'react';
import RitualForm from "../../components/Rituals/RitualForm/RitualForm";
var Ritual = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u0440\u0438\u0442\u0443\u0430\u043B"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(RitualForm, null))))));
};
export default Ritual;



//////////////////
// WEBPACK FOOTER
// ./src/views/Rituals/Ritual.tsx
// module id = 440
// module chunks = 0